import { useGetOrganizationWebhookStatisticsQuery } from '@/services/organizations';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { useMemo } from 'react';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export const WebhookLogChart = ({ organizationAlias }: { organizationAlias: string }) => {
  const { data } = useGetOrganizationWebhookStatisticsQuery({ alias: organizationAlias });

  const filledData = useMemo(() => {
    const now = new Date();
    now.setUTCMinutes(0, 0, 0);

    return Array.from({ length: 24 }, (_, i) => {
      const bucket = new Date(now);
      bucket.setUTCHours(now.getUTCHours() - (23 - i));
      const key = bucket.toISOString();

      const match = data?.find((x) => new Date(x._id).toISOString() === key);
      return {
        _id: key,
        successCount: match?.successCount ?? 0,
        failureCount: match?.failureCount ?? 0,
        skipCount: match?.skipCount ?? 0,
      };
    });
  }, [data]);

  const labels = filledData.map((x) => {
    const d = new Date(x._id);
    const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(d.getUTCDate()).padStart(2, '0');
    const hh = String(d.getUTCHours()).padStart(2, '0');
    return `${mm}/${dd} ${hh}:00 UTC`;
  });

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Successful Calls',
        data: filledData.map((x) => x.successCount),
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'rgba(75,192,192,1)',
        borderWidth: 1,
      },
      {
        label: 'Failed Calls',
        data: filledData.map((x) => x.failureCount),
        backgroundColor: 'rgba(255,99,132,0.4)',
        borderColor: 'rgba(255,99,132,1)',
        borderWidth: 1,
      },
      {
        label: 'Skipped Calls',
        data: filledData.map((x) => x.skipCount),
        backgroundColor: 'rgba(201,203,207,0.4)',
        borderColor: 'rgba(201,203,207,1)',
        borderWidth: 1,
      },
    ],
  };

  return (
    <Line
      data={chartData}
      options={{
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: true,
            text: 'Webhook Call History',
          },
        },
      }}
    />
  );
};
